import React from "react";
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Sororin - Κατάστημα Ομορφιάς</title>
        <meta
          name="description"
          content="Sororin - Κατάστημα Ομορφιάς με προϊόντα υψηλής ποιότητας. Ανακαλύψτε την πολυτελή συλλογή μας από προϊόντα περιποίησης και ομορφιάς."
        />
      </Helmet>

      <div className="policy-container">
        <div className="policy-content">
          <h1>Πολιτική Απορρήτου</h1>
          <p className="last-updated">
            Τελευταία ενημέρωση: {new Date().toLocaleDateString("el-GR")}
          </p>

          <section>
            <h2>1. Εισαγωγή</h2>
            <p>
              Η Sororin ("εμείς", "εμάς", "μας") δεσμεύεται να προστατεύει την
              ιδιωτικότητά σας. Η παρούσα Πολιτική Απορρήτου εξηγεί πώς
              συλλέγουμε, χρησιμοποιούμε, αποκαλύπτουμε και προστατεύουμε τις
              προσωπικές σας πληροφορίες όταν επισκέπτεστε τον ιστότοπό μας και
              χρησιμοποιείτε τις υπηρεσίες μας.
            </p>
          </section>

          <section>
            <h2>2. Πληροφορίες που Συλλέγουμε</h2>

            <h3>2.1 Πληροφορίες που Παρέχετε</h3>
            <ul>
              <li>Ονοματεπώνυμο</li>
              <li>Διεύθυνση email</li>
              <li>Αριθμός τηλεφώνου</li>
              <li>Διεύθυνση αποστολής και χρέωσης</li>
              <li>Στοιχεία πληρωμής</li>
              <li>Ιστορικό παραγγελιών</li>
            </ul>

            <h3>2.2 Αυτόματα Συλλεγόμενες Πληροφορίες</h3>
            <ul>
              <li>Διεύθυνση IP</li>
              <li>Τύπος προγράμματος περιήγησης</li>
              <li>Σελίδες που επισκέπτεστε</li>
              <li>Χρόνος και ημερομηνία επίσκεψης</li>
              <li>Cookies και παρόμοιες τεχνολογίες</li>
            </ul>
          </section>

          <section>
            <h2>3. Πώς Χρησιμοποιούμε τις Πληροφορίες σας</h2>
            <p>Χρησιμοποιούμε τις προσωπικές σας πληροφορίες για:</p>
            <ul>
              <li>Επεξεργασία και εκπλήρωση των παραγγελιών σας</li>
              <li>Επικοινωνία μαζί σας σχετικά με τις παραγγελίες σας</li>
              <li>Παροχή εξυπηρέτησης πελατών</li>
              <li>
                Αποστολή ενημερωτικών δελτίων και προωθητικών υλικών (με τη
                συγκατάθεσή σας)
              </li>
              <li>Βελτίωση του ιστότοπου και των υπηρεσιών μας</li>
              <li>Πρόληψη απάτης και διασφάλιση ασφάλειας</li>
              <li>Συμμόρφωση με νομικές υποχρεώσεις</li>
            </ul>
          </section>

          <section>
            <h2>4. Κοινοποίηση Πληροφοριών</h2>
            <p>Ενδέχεται να κοινοποιήσουμε τις πληροφορίες σας σε:</p>
            <ul>
              <li>
                Παρόχους υπηρεσιών που μας βοηθούν στη λειτουργία της
                επιχείρησής μας (π.χ. εταιρείες αποστολής, επεξεργαστές
                πληρωμών)
              </li>
              <li>Νομικές αρχές όταν απαιτείται από το νόμο</li>
              <li>Εταιρείες με τις οποίες συγχωνευόμαστε ή εξαγοραζόμαστε</li>
            </ul>
            <p>
              Δεν πουλάμε ποτέ τα προσωπικά σας δεδομένα σε τρίτους για δικούς
              τους εμπορικούς σκοπούς.
            </p>
          </section>

          <section>
            <h2>5. Cookies και Τεχνολογίες Παρακολούθησης</h2>
            <p>
              Χρησιμοποιούμε cookies και παρόμοιες τεχνολογίες για να
              βελτιώσουμε την εμπειρία σας. Τα cookies είναι μικρά αρχεία που
              αποθηκεύονται στη συσκευή σας. Μπορείτε να ελέγξετε τη χρήση των
              cookies μέσω των ρυθμίσεων του προγράμματος περιήγησής σας.
            </p>
            <p>Χρησιμοποιούμε:</p>
            <ul>
              <li>Απαραίτητα cookies για τη λειτουργία του ιστότοπου</li>
              <li>Cookies απόδοσης για ανάλυση χρήσης</li>
              <li>Cookies μάρκετινγκ για εξατομικευμένες διαφημίσεις</li>
            </ul>
          </section>

          <section>
            <h2>6. Ασφάλεια Δεδομένων</h2>
            <p>
              Λαμβάνουμε κατάλληλα τεχνικά και οργανωτικά μέτρα για την
              προστασία των προσωπικών σας δεδομένων από μη εξουσιοδοτημένη
              πρόσβαση, απώλεια ή καταστροφή. Αυτά περιλαμβάνουν:
            </p>
            <ul>
              <li>Κρυπτογράφηση SSL/TLS</li>
              <li>Ασφαλείς servers</li>
              <li>Περιορισμένη πρόσβαση στα δεδομένα</li>
              <li>Τακτικές εξετάσεις ασφαλείας</li>
            </ul>
          </section>

          <section>
            <h2>7. Τα Δικαιώματά σας (GDPR)</h2>
            <p>
              Σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR), έχετε
              το δικαίωμα:
            </p>
            <ul>
              <li>Πρόσβασης στα προσωπικά σας δεδομένα</li>
              <li>Διόρθωσης ανακριβών δεδομένων</li>
              <li>Διαγραφής των δεδομένων σας ("δικαίωμα στη λήθη")</li>
              <li>Περιορισμού της επεξεργασίας</li>
              <li>Φορητότητας των δεδομένων</li>
              <li>Εναντίωσης στην επεξεργασία</li>
              <li>Ανάκλησης συγκατάθεσης ανά πάσα στιγμή</li>
            </ul>
            <p>
              Για να ασκήσετε οποιοδήποτε από αυτά τα δικαιώματα, επικοινωνήστε
              μαζί μας στο
              <a href="mailto:sororin@hotmail.com">sororin@hotmail.com</a>
            </p>
          </section>

          <section>
            <h2>8. Διατήρηση Δεδομένων</h2>
            <p>
              Διατηρούμε τις προσωπικές σας πληροφορίες για όσο διάστημα είναι
              απαραίτητο για την εκπλήρωση των σκοπών που περιγράφονται σε αυτή
              την πολιτική, εκτός εάν απαιτείται ή επιτρέπεται από το νόμο
              μεγαλύτερη περίοδος διατήρησης.
            </p>
          </section>

          <section>
            <h2>9. Υπηρεσίες Τρίτων</h2>
            <p>
              Ο ιστότοπός μας μπορεί να περιέχει συνδέσμους προς ιστότοπους
              τρίτων:
            </p>
            <ul>
              <li>Google Analytics - για ανάλυση κίνησης</li>
              <li>Facebook Pixel - για διαφημίσεις</li>
              <li>Επεξεργαστές πληρωμών - για ασφαλείς συναλλαγές</li>
            </ul>
            <p>
              Δεν ευθυνόμαστε για τις πολιτικές απορρήτου αυτών των τρίτων. Σας
              ενθαρρύνουμε να διαβάσετε τις πολιτικές τους.
            </p>
          </section>

          <section>
            <h2>10. Δικαιώματα Ανηλίκων</h2>
            <p>
              Οι υπηρεσίες μας δεν απευθύνονται σε άτομα κάτω των 16 ετών. Δεν
              συλλέγουμε εν γνώσει μας προσωπικές πληροφορίες από ανηλίκους. Εάν
              πιστεύετε ότι έχουμε συλλέξει πληροφορίες από ανήλικο,
              επικοινωνήστε μαζί μας αμέσως.
            </p>
          </section>

          <section>
            <h2>11. Διεθνείς Μεταφορές Δεδομένων</h2>
            <p>
              Τα δεδομένα σας μπορεί να μεταφερθούν και να αποθηκευτούν σε
              servers εκτός της Ευρωπαϊκής Ένωσης. Διασφαλίζουμε ότι οποιαδήποτε
              μεταφορά γίνεται σύμφωνα με τους κανονισμούς του GDPR και με
              κατάλληλες εγγυήσεις.
            </p>
          </section>

          <section>
            <h2>12. Αλλαγές στην Πολιτική Απορρήτου</h2>
            <p>
              Ενδέχεται να ενημερώσουμε αυτή την πολιτική απορρήτου περιοδικά.
              Θα σας ειδοποιήσουμε για τυχόν σημαντικές αλλαγές μέσω email ή
              ειδοποίησης στον ιστότοπό μας. Η συνέχιση χρήσης των υπηρεσιών μας
              μετά από αλλαγές συνιστά αποδοχή της νέας πολιτικής.
            </p>
          </section>

          <section>
            <h2>13. Επικοινωνία</h2>
            <p>
              Για ερωτήσεις ή ανησυχίες σχετικά με αυτή την πολιτική απορρήτου ή
              τις πρακτικές διαχείρισης δεδομένων μας, επικοινωνήστε μαζί μας:
            </p>
            <div className="contact-info">
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:sororin@hotmail.com">sororin@hotmail.com</a>
              </p>
              <p>
                <strong>Τηλέφωνο:</strong> +302394023553
              </p>
              <p>
                <strong>Διεύθυνση:</strong> Λεωφόρος Βενιζέλος, 2, Λαγκαδάς, 898
                60, Ελλάδα
              </p>
            </div>
          </section>

          <section>
            <h2>14. Αρχή Προστασίας Δεδομένων</h2>
            <p>
              Έχετε το δικαίωμα να υποβάλετε καταγγελία στην Αρχή Προστασίας
              Δεδομένων Προσωπικού Χαρακτήρα (ΑΠΔΠΧ) εάν πιστεύετε ότι η
              επεξεργασία των προσωπικών σας δεδομένων παραβιάζει το νόμο.
            </p>
            <div className="contact-info">
              <p>
                <strong>Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα</strong>
              </p>
              <p>Κηφισίας 1-3, 115 23 Αθήνα</p>
              <p>Τηλ: +30 210 6475600</p>
              <p>
                Email:{" "}
                <a href="mailto:sororin@hotmail.com">sororin@hotmail.com</a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
